import { createQueryKeys } from "@lukemorales/query-key-factory"

import axios from "@/api/axios"
import { APIFn } from "@/api/utils"

import { Organization } from "./types"

export const OrganizationQueryKey = createQueryKeys("organization", {
  list: (params: any) => ({ queryKey: ["organization-list", params] }),
  retrieve: (props: { id?: string }, params: Record<string, any>) => ({
    queryKey: ["retrieve-organisation", props.id, params],
  }),
})

type OrganizationResourceType = {
  list: APIFn<Organization[]>
  retrieve: APIFn<Organization, { id: string }>
  create: APIFn<void, { id: string }>
}

export const OrganizationResource: OrganizationResourceType = {
  list: ({ ...config }) => axios.get("/eris/v1/organizations/", config),
  retrieve: ({ urlParams, ...config }) =>
    axios.get(`/eris/v1/organizations/${urlParams.id}/`, config),
  create: ({ urlParams, data, ...config }) =>
    axios.post(`/eris/v1/organizations/${urlParams.id}/`, data, config),
}
